<div class="clr"></div>
<div *ngIf="showMessage" class="marquee">
    <div class="marquee-content">
      {{ messagescroll }}
    </div>
</div>
<!-- <mat-toolbar class="mat-toolbar listps" color="accent" style="color:#000;">
    <div style="width: 100%;font-weight:bold;">
        Telemetry & Network Operations
    </div>
</mat-toolbar> -->
<mat-tab-group style="width: 100%;" class="demo-tab-group">
    <mat-tab label="Telemetry">
        <!--Teleetry Page-->
        <div class="p10"></div>
        <mat-label *ngIf="showTelemetryNoResults">
            <div class="noResult">There is no telemetry data available for this power supply {{psname}}</div>
            <br>
        </mat-label>

        <div class="p10"></div>
        <mat-label *ngIf="showErrormsg">
            <div class="noResult">Something went wrong and unable to load telemetry!</div>
            <br>
        </mat-label>


        <div *ngIf="showProgressBartelemetry">
            <div class="lmask"></div>
        </div>
        <div *ngIf="showTelemetryResults">
            <p *ngIf="reftimedata" class="poll">
                <b><div class="fa fa-spinner {{spin}}"></div>&nbsp;Last Poll Time :
                    <!-- {{refreshTime | date:'MMM d, y hh:mm:ss a'}} -->
                    <span [style.color]="refcolor == 'amber' ? '#FFBF00' : 'black'">{{refreshTime | date:'MMM d, y hh:mm:ss a'}}</span>
                </b>
                <br/>
                <b><span class="offtime" *ngIf = "offlinetime != 'NA'">
                    Offline Timestamp : {{ offlinetime | date:'MMM d, y hh:mm:ss a' }}
                </span></b>
                <b><span class="offtime" *ngIf = "offlinetime == 'NA'">
                    Offline Timestamp : {{ offlinetime }}
                </span></b>
            </p>
            <p *ngIf="!reftimedata" class="poll">
                <b><div class="fa fa-spinner {{spin}}"></div>&nbsp;Last Poll Time : NA</b>
                <br/>
                <b><span class="offtime" *ngIf = "offlinetime != 'NA'">
                    Offline Timestamp : {{ offlinetime | date:'MMM d, y hh:mm:ss a' }}
                </span></b>
                <b><span class="offtime" *ngIf = "offlinetime == 'NA'">
                    Offline Timestamp : {{ offlinetime }}
                </span></b>
            </p>
            <mat-card class="card p5">
                <mat-card-content style="margin-bottom: 20px;">
                    <div class="fontTelestat"><b>Inverter Status</b>
                      <span *ngIf="!vm.generatorDeployed">
                        <span *ngIf="macSearchTelemetry.inverterStatus == 'NORMAL'"
                            class="labelStruccolor">{{macSearchTelemetry.inverterStatus}}</span>
                        <span *ngIf="macSearchTelemetry.inverterStatus == 'LINE FAILED'"
                            class="labelStruccolorlnfd">{{macSearchTelemetry.inverterStatus}}</span>
                        <span *ngIf="macSearchTelemetry.inverterStatus == 'ON: Local Test Cycle'"
                            class="labelStruccolor">{{macSearchTelemetry.inverterStatus}}</span>
                        <span *ngIf="macSearchTelemetry.inverterStatus == 'ON: Remote test initiated'"
                            class="labelStruccolor">{{macSearchTelemetry.inverterStatus}}</span>
                        <span *ngIf="macSearchTelemetry.inverterStatus == 'ALARM: Last Test Failed'"
                            class="labelStruccolorlnfd">{{macSearchTelemetry.inverterStatus}}</span>
                        <span *ngIf="macSearchTelemetry.inverterStatus == 'OFFLINE' && macSearchTelemetry.psConnectedCount !== null"
                            class="labelStruccolorlnfd">{{macSearchTelemetry.inverterStatus}}</span>

                        <span *ngIf="reftimedata && macSearchTelemetry.inverterStatus == 'OFFLINE' && macSearchTelemetry.psConnectedCount === null"
                        class="labelStruccolorlnfd">Online - Not Detecting PS</span>
                        <span *ngIf="!reftimedata" class="labelStruccolorlnfd">OFFLINE: UNKNOWN</span>
                        <span *ngIf="macSearchTelemetry.inverterStatus == null" class="labelStrucval">-</span>
                      </span>
                      <span *ngIf="vm.generatorDeployed" class="labelStruccolor">ON GENERATOR</span>
                    </div>
                    <div class="fontTelestat" *ngIf="generatorId !== null && generatorId > 0 && !vm.generatorDeployed"><span class="text-type-bold">Generator Deployed</span>
                        <span class="labelColorGenerator"><a matTooltip="Powerhouse Details"
                            target="_blank"
                            href="https://nedxoc.cable.comcast.com/Powerhouse/?macaddress={{macaddress}}"><b>{{genMinRemaining}} Minute(s) Remaining</b></a></span><br>
                    </div>
                    <div *ngIf="vm.generatorDeployed && vm.generatorMinutesRuntimeConverted !== null"
                         class="font-telestat power-source-container">
                      <div class="text-panel-left">
                          <p class="text-type-bold">Generator Deployed</p>
                      </div>
                      <div class="button-section-right">
                        <p class="label-struc-color-blue minutes-remaining-text">
                          {{vm.generatorMinutesRuntimeConverted}} Minute(s) Remaining
                        </p>
                      </div>
                    </div>

                    <div class="fontTelestat"><b>Major Alarm</b>
                        <span *ngIf="macSearchTelemetry.majorAlarm == 'ALARM'"
                            class="labelStruccolorAlarm">{{ macSearchTelemetry.majorAlarm }}</span>
                        <span *ngIf="macSearchTelemetry.majorAlarm == 'MINOR'"
                            class="labelStruccolorMinor">{{ macSearchTelemetry.majorAlarm }}</span>
                        <span *ngIf="macSearchTelemetry.majorAlarm == 'NO'"
                            class="labelStruccolor">{{ macSearchTelemetry.majorAlarm }}</span>
                        <span *ngIf="macSearchTelemetry.majorAlarm == 'ALARM - Loss of Communication'"
                            class="labelStruccolorAlarm">ALARM - Loss of Comm</span>
                        <span *ngIf="macSearchTelemetry.majorAlarm == null" class="labelStrucvalalpha">-</span>
                    </div>
                    <div class="fontTelestat"><b>Minor Alarm</b>
                        <span *ngIf="macSearchTelemetry.minorAlarm == 'MINOR ALARM'"
                            class="labelStruccolorAlarm">{{ macSearchTelemetry.minorAlarm }}</span>
                        <span *ngIf="macSearchTelemetry.minorAlarm == 'NO'"
                            class="labelStruccolor">{{ macSearchTelemetry.minorAlarm }}</span>
                        <span *ngIf="macSearchTelemetry.minorAlarm == null" class="labelStrucvalalpha">-</span>
                    </div>
                     <!--If the inverter status is line Failed we are showing the three battery fields-->
                     <div *ngIf="macSearchTelemetry.inverterStatus == 'LINE FAILED'">
                    <div *ngIf="macSearchTelemetry.psExpectedFailureTime">
                        <label class="alertProfilelab"><strong>Expected Failure Time</strong></label>
                        <span class="alertProfilelabdata">
                            {{ psExpectedFailureTimeFormated }}
                        </span>
                    </div>
                    <div *ngIf="macSearchTelemetry.psExpectedFailureTime == null">
                        <label class="alertProfilelab"><strong>Expected Failure Time</strong></label>
                        <span class="alertProfilelabdata">NA</span>
                    </div>
                    <div style="clear: both;"></div>
                    <div *ngIf="macSearchTelemetry.batteryTimeRemainingInMins">
                        <label class="alertProfilelab"><strong>Battery Runtime Remaining</strong></label>
                        <span class="alertProfilelabdata">
                            {{ macSearchTelemetry.batteryTimeRemainingInMins }} Mins
                        </span>
                    </div>
                    <div *ngIf="macSearchTelemetry.batteryTimeRemainingInMins == null">
                        <label class="alertProfilelab"><strong>Battery Runtime Remaining</strong></label>
                        <span class="alertProfilelabdata">NA</span>
                    </div>
                    <div style="clear: both;"></div>
                    <div *ngIf="macSearchTelemetry.psOnBatterySince">
                        <label class="alertProfilelab"><strong>On Battery Since</strong></label>
                        <span class="alertProfilelabdata">
                            {{ psOnBatterySinceFormated }}
                        </span>
                    </div>
                    <div *ngIf="macSearchTelemetry.psOnBatterySince == null">
                        <label class="alertProfilelab"><strong>On Battery Since</strong></label>
                        <span class="alertProfilelabdata">NA</span>
                    </div>
                    <div style="clear: both;"></div>
                    </div>
                    <!-- <div class="fontTelestat"><b>PS Score</b><span
                        class="labelStrucvalalpha" style="text-align: center;">{{ macSearchTelemetry.psScore != null ? macSearchTelemetry.psScore : '-' }}</span>
                    </div> -->
                    <div class="font-telestat power-source-container">
                      <div class="text-panel-left">
                          <p class="text-type-bold">Power Source</p>
                      </div>
                      <div class="button-section-right">
                          <span *ngIf="vm.recoverDeployEnabled === 1 ? false : true">
                          <button
                              *ngIf="!vm.generatorDeployed"
                              class="deploy-generator-bg-color power-source-label"
                              mat-raised-button
                              [disabled]="vm.recoverDeployEnabled === 2"
                              (click)="generatorSearchDialog()">
                              Deploy Generator
                          </button>
                          </span>
                          <span *ngIf="vm.recoverDeployEnabled === 1 ? false : true">
                          <button
                              *ngIf="vm.generatorDeployed"
                              class="power-source-label recover-generator-bg-color"
                              mat-raised-button
                              [disabled]="vm.recoverDeployEnabled === 2"
                              (click)="refuelRecoverGeneratorDialog(vm.RefuelRecoverAction.Recover)">
                              Recover Generator
                          </button>
                          </span>
                          <button
                            *ngIf="vm.generatorDeployed"
                            class="power-source-label refuel-generator-bg-color"
                            mat-raised-button
                            (click)="refuelRecoverGeneratorDialog(vm.RefuelRecoverAction.Refuel)">
                            Refuel Generator
                          </button>
                      </div>
                    </div>
                    <div>
                        <label class="alertProfilelab telemetry-label">Test Time</label>
                        <span class="alertProfilelabdata">
                            {{ macSearchTelemetry.testDurationInMin != null ? macSearchTelemetry.testDurationInMin +' Mins': '-' }}
                            <br><button  mat-raised-button [disabled]="correctruntimedisabled" *ngIf="macSearchTelemetry.testDurationInMin !=(12 || 120) && macSearchTelemetry.testDurationInMin != null" (click)="editTestDuration()" matTooltip="Correct Runtime" mat-raised-button class="small"><span>Correct Runtime</span></button>
                        </span>
                    </div>
                    <div style="clear: both;"></div>

                    <div style="clear: both;"></div>
                    <div *ngIf="macSearchTelemetry.rmodeXm3 != null || macSearchTelemetry.rmodeXm3 != undefined">
                        <label class="alertProfilelab"><strong>RMODE</strong></label>
                        <span class="alertProfilelabdata">
                            {{ macSearchTelemetry.rmodeXm3}}</span>
                    </div>
                    <div *ngIf="macSearchTelemetry.rmodeXm31 != null || macSearchTelemetry.rmodeXm31 != undefined">
                        <label class="alertProfilelab"><strong>RMODE</strong></label>
                        <span class="alertProfilelabdata">
                            {{ macSearchTelemetry.rmodeXm31}}</span>
                    </div>
                    <div style="clear: both;"></div>
                    <div *ngIf="macSearchTelemetryThreshold!= null && macSearchTelemetryThreshold!= ''">
                        <label class="alertProfilelab"><strong>Alert Profile Name</strong></label>
                        <span class="alertProfilelabdata">
                            {{macSearchTelemetryThreshold[0].alertProfile}}&nbsp;<a style="cursor: pointer;"
                                (click)="openthresholdDialog()"><i class="fa fa-info-circle fa-lg"></i></a>
                        </span>
                    </div>
                    <div *ngIf="macSearchTelemetryThreshold== ''">
                        <label class="alertProfilelab"><strong>Alert Profile Name</strong></label>
                        <span class="alertProfilelabdata">-</span>
                    </div>
                    <div style="clear: both;"></div>
                    <!-- <div>
                        <label class="alertProfilelab"><strong>Alpha PM Certification Report</strong></label>
                        <span class="alertProfilelabdata">
                            <a style="cursor: pointer;"
                                (click)="downloadPDF()"><div><mat-icon>get_app</mat-icon><span class="aligned-with-icon">Click for details</span></div></a>
                        </span>
                    </div> -->
                    <div>
                        <label class="alertProfilelab"><strong>Calculated Runtime</strong></label>
                        <span class="alertProfilelabdata">
                            {{ macSearchTelemetry.calculatedRuntime != null ? macSearchTelemetry.calculatedRuntime +' Minute(s)' : '-' }}
                        </span>
                    </div>
                    <div style="clear: both;"></div>
                </mat-card-content>
            </mat-card>
            <div *ngIf="showTelemetryThreshold">
                <!--Color Bar removed-->
                <!-- <table>
            <tr>
                <td class="tablelabelcolor"><b>Input Voltage</b></td>
                <td>
                    <div class="containerVal" id="in_voltage"></div>
                </td>
            </tr>
            <tr>
                <td class="tablelabelcolor"><b>Output Voltage</b></td>
                <td>
                    <div class="containerVal" id="out_voltage"></div>
                </td>
            </tr>
            <tr>
                <td class="tablelabelcolor"><b>Output Current 1</b></td>
                <td>
                    <div class="containerVal" id="out_current1"></div>
                </td>
            </tr>
            <tr *ngIf="macSearchTelemetry.outputCurrent2 != null">
                <td class="tablelabelcolor"><b>Output Current 2</b></td>
                <td>
                    <div class="containerVal" id="out_current2"></div>
                </td>
            </tr>
            <tr>
                <td class="tablelabelcolor"><b>Output Power</b></td>
                <td>
                    <div class="containerVal" id="out_power"></div>
                </td>
            </tr>
            <tr>
                <td class="tablelabelcolor"><b>Temperature</b></td>
                <td>
                    <div class="containerVal" id="temprature"></div>
                </td>
            </tr>
            <tr>
                <td class="tablelabelcolor"><b>Total String Voltage</b></td>
                <td>
                    <div class="containerVal" id="total_string_voltage"></div>
                </td>
            </tr>
        </table> -->
                <!--Adding only Numbers with color box-->
                <div class="fontTelestat"><b>Input Voltage</b>
                    <span *ngIf="macSearchTelemetry.inputVoltage != null"
                        [ngStyle]="{'background-color': colorValueinvolt}"
                        class="labelStruccolor">{{macSearchTelemetry.inputVoltage + ' VAC'}}</span>
                    <span *ngIf="macSearchTelemetry.inputVoltage == null" class="labelStrucval"
                        style="text-align: center;">-</span>
                    <!-- <span class="labelStrucval">{{macSearchTelemetry.inputVoltage != null ? macSearchTelemetry.inputVoltage + ' VAC' : '-'}}
        </span> -->
                </div><br>
                <div class="fontTelestat"><b>Output Voltage</b>
                    <!-- <span class="labelStrucval">{{macSearchTelemetry.outputVoltage != null ? macSearchTelemetry.outputVoltage + ' Volt(s)' : '-'}}
            </span> -->
                    <span *ngIf="macSearchTelemetry.outputVoltage != null"
                        [ngStyle]="{'background-color': colorValueoutvolt}"
                        class="labelStruccolor">{{macSearchTelemetry.outputVoltage + ' Volt(s)'}}</span>
                    <span *ngIf="macSearchTelemetry.outputVoltage == null" class="labelStrucval"
                        style="text-align: center;">-</span>
                </div><br>
                <div class="fontTelestat"><b>Output Current1</b>
                    <span *ngIf="macSearchTelemetry.outputCurrent1 != null"
                        [ngStyle]="{'background-color': colorValueoutcurr1}"
                        class="labelStruccolor">{{macSearchTelemetry.outputCurrent1 + ' Amp(s)'}}</span>
                    <span *ngIf="macSearchTelemetry.outputCurrent1 == null" class="labelStrucval"
                        style="text-align: center;">-</span>
                </div><br>
                <div *ngIf="macSearchTelemetry.outputCurrent2 != null" class="fontTelestat"><b>Output Current2</b>
                    <span [ngStyle]="{'background-color': colorValueoutcurr2}"
                        class="labelStruccolor">{{macSearchTelemetry.outputCurrent2 + ' Amp(s)'}}</span><br>
                </div>

                <!-- <div *ngIf="macSearchTelemetry.outputCurrent1 != null && macSearchTelemetry.outputCurrent2 != null" class="fontTelestat"><b>Output Current Total</b>
                    <span class="labelStrucval">
                        {{macSearchTelemetry.outputCurrent1 + macSearchTelemetry.outputCurrent2  +" Amp(s)" }}
                    </span>
                </div><br> -->

                <div *ngIf="macSearchTelemetry.outputCurrent1 != null && macSearchTelemetry.outputCurrent2 != null" class="fontTelestat"><b>Output Current Total</b>
                    <span
                        [ngStyle]="{'background-color': colorValuetotal}"
                        class="labelStruccolor">{{macSearchTelemetry.outputCurrent1 + macSearchTelemetry.outputCurrent2  +" Amp(s)" }}</span><br>
                </div>

                <div class="fontTelestat"><b>Output Power</b>
                    <!-- <span class="labelStrucval">{{macSearchTelemetry.powerOut != null ? macSearchTelemetry.powerOut + ' Watt(s)': '-'}}
            </span> -->
                    <span *ngIf="macSearchTelemetry.powerOut != null"
                        [ngStyle]="{'background-color': colorValueoutpower}"
                        class="labelStruccolor">{{macSearchTelemetry.powerOut + ' Watt(s)'}}</span>
                    <span *ngIf="macSearchTelemetry.powerOut == null" class="labelStrucval"
                        style="text-align: center;">-</span>
                </div><br>
                <div class="fontTelestat"><b>Temperature</b>
                    <!-- <span
                class="labelStrucval">{{macSearchTelemetry.outsideTemperatureFahrenheit != null ? macSearchTelemetry.outsideTemperatureFahrenheit + ' F' : '-'}}
            </span> -->
                    <span *ngIf="macSearchTelemetry.outsideTemperatureFahrenheit != null"
                        [ngStyle]="{'background-color': colorValuetemp}"
                        class="labelStruccolor">{{macSearchTelemetry.outsideTemperatureFahrenheit + ' F'}}</span>
                    <span *ngIf="macSearchTelemetry.outsideTemperatureFahrenheit == null" class="labelStrucval"
                        style="text-align: center;">-</span>
                </div><br>
                <div *ngIf="macSearchTelemetry.batteryStringCount != 0" class="fontTelestat"><b>Total String Voltage</b>
                    <!-- <span
                class="labelStrucval">{{macSearchTelemetry.totalBatteryStringVoltage != null ? macSearchTelemetry.totalBatteryStringVoltage + ' VDC' : '-'}}
            </span> -->
                    <span *ngIf="macSearchTelemetry.totalBatteryStringVoltage != null"
                        [ngStyle]="{'background-color': colorValuetotalstr}"
                        class="labelStruccolor">{{macSearchTelemetry.totalBatteryStringVoltage + ' VDC'}}</span>
                    <span *ngIf="macSearchTelemetry.totalBatteryStringVoltage == null" class="labelStrucval"
                        style="text-align: center;">-</span>
                </div><br>

            </div>

            <div *ngIf="!showTelemetryThreshold">
                <div class="fontTelestat"><b>Input Voltage</b><span
                        class="labelStrucval">{{macSearchTelemetry.inputVoltage != null ? macSearchTelemetry.inputVoltage + ' VAC' : '-'}}
                    </span>
                </div><br>
                <div class="fontTelestat"><b>Output Voltage</b><span
                        class="labelStrucval">{{macSearchTelemetry.outputVoltage != null ? macSearchTelemetry.outputVoltage + ' Volt(s)' : '-'}}
                    </span>
                </div><br>
                <div class="fontTelestat"><b>Output Current1</b><span
                        class="labelStrucval">{{macSearchTelemetry.outputCurrent1 != null ? macSearchTelemetry.outputCurrent1 + ' Amp(s)' : '-'}}
                    </span>
                </div><br>
                <div class="fontTelestat"><b>Output Current2</b><span
                        class="labelStrucval">{{macSearchTelemetry.outputCurrent2 != null ? macSearchTelemetry.outputCurrent2 + ' Amp(s)' : '-'}}
                    </span>
                </div><br>
                <div class="fontTelestat"><b>Output Power</b><span
                        class="labelStrucval">{{macSearchTelemetry.powerOut != null ? macSearchTelemetry.powerOut + ' Watt(s)': '-'}}
                    </span>
                </div><br>
                <div class="fontTelestat"><b>Temperature</b><span
                        class="labelStrucval">{{macSearchTelemetry.outsideTemperatureFahrenheit != null ? macSearchTelemetry.outsideTemperatureFahrenheit + ' F' : '-'}}
                    </span>
                </div><br>
                <div class="fontTelestat"><b>Total String Voltage</b><span
                        class="labelStrucval">{{macSearchTelemetry.totalBatteryStringVoltage != null ? macSearchTelemetry.totalBatteryStringVoltage + ' VDC' : '-'}}
                    </span>
                </div><br>
            </div>
            <div class="headernw">
                <div>Advance Battery Info</div>
            </div>
            <table>
                <tr *ngIf="isLionBMS && !parallelBatts">
                    <td  class="tablelabel"><b># of Batteries</b></td>
                    <td class="tablevalue">
                        1LionBMS
                    </td>
                </tr>

                <tr *ngIf="!isLionBMS && !parallelBatts">
                    <td  class="tablelabel"><b># of Batteries</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.batteryCount != null ? macSearchTelemetry.batteryCount + " Batteries" : '-' }}
                    </td>
                </tr>

                <tr *ngIf="!isLionBMS && parallelBatts">
                    <td  class="tablelabel"><b># of Batteries</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.batteryCount != null ? macSearchTelemetry.parallelBattsCount + " Batteries (Parallel)" : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b># of Strings</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.batteryStringCount != null ? macSearchTelemetry.batteryStringCount + " String(s)": '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Total Bat. String Voltage</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.totalBatteryStringVoltage != null ? macSearchTelemetry.totalBatteryStringVoltage +" VDC": '-' }}
                    </td>
                </tr>

                    <!-- <tr *ngIf="isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat. {{macSearchTelemetry.parallelBattsCount}} Parallel</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat. {{macSearchTelemetry.parallelBattsCount}} Parallel</b></td>
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_1 != null" [ngStyle]="{'background-color': colorbat1}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}
                        </td>
                    </tr> -->

                    <tr *ngIf="!isLionBMS && parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat. {{macSearchTelemetry.parallelBattsCount}} Parallel</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat. {{macSearchTelemetry.parallelBattsCount}} Parallel</b></td>
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_1 != null" [ngStyle]="{'background-color': colorbat1}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}
                        </td>
                    </tr>

                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.1</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_2 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.2</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_3 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.3</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_4 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.4</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.1</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_2 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.2</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_3 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.3</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_4 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.4</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.1</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_2 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.2</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_3 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.3</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_4 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.4</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.1</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_2 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.2</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_3 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.3</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_4 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.4</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.1</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage5_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_2 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.2</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage5_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_3 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.3</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage5_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_4 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.4</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage5_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_1 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.1</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage6_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_2 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.2</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage6_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_3 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.3</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage6_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_4 != null && !showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.4</b></td>
                        <td class="tablevalue">{{macSearchTelemetry.batteryVoltage6_4 +" VDC" }}</td>
                    </tr>
                    <!--Adding only Numbers for battery section-->

                    <tr *ngIf="isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>1LionBMS</b></td>
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_1 != null" [ngStyle]="{'background-color': colorbat1}" class="tablevalue"
                            style="float: left;">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}
                        </td>
                    </tr>

                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.1</b></td>
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_1 != null" [ngStyle]="{'background-color': colorbat1}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage1_1 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_2 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.2</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_2 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_2 != null" [ngStyle]="{'background-color': colorbat2}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage1_2 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_3 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.3</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_3 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_3 != null" [ngStyle]="{'background-color': colorbat3}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage1_3 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage1_4 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 1 Bat.4</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage1_4 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage1_4 != null" [ngStyle]="{'background-color': colorbat4}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage1_4 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.1</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_1 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage2_1 != null" [ngStyle]="{'background-color': colorbat5}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage2_1 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_2 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.2</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_2 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage2_2 != null" [ngStyle]="{'background-color': colorbat6}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage2_2 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_3 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.3</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_3 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage2_3 != null" [ngStyle]="{'background-color': colorbat7}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage2_3 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage2_4 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 2 Bat.4</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage2_4 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage2_4 != null" [ngStyle]="{'background-color': colorbat8}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage2_4 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.1</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_1 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage3_1 != null" [ngStyle]="{'background-color': colorbat9}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage3_1 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_2 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.2</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_2 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage3_2 != null" [ngStyle]="{'background-color': colorbat10}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage3_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_3 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.3</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_3 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage3_3 != null" [ngStyle]="{'background-color': colorbat11}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage3_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage3_4 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 3 Bat.4</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_4 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage3_4 != null" [ngStyle]="{'background-color': colorbat12}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage3_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.1</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_1 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage4_1 != null" [ngStyle]="{'background-color': colorbat13}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage4_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_2 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.2</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_2 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage4_2 != null" [ngStyle]="{'background-color': colorbat14}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage4_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_3 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.3</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_3 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage4_3 != null" [ngStyle]="{'background-color': colorbat15}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage4_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage4_4 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 4 Bat.4</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_4 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage4_4 != null" [ngStyle]="{'background-color': colorbat16}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage4_4 +" VDC" }}</td>
                    </tr>

                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.1</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_1 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage5_1 != null" [ngStyle]="{'background-color': colorbat17}"
                            style="float: left;" class="labelStruccolor">{{macSearchTelemetry.batteryVoltage5_1 +" VDC" }}
                        </td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_2 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.2</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_2 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage5_2 != null" [ngStyle]="{'background-color': colorbat18}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage5_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_3 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.3</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_3 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage5_3 != null" [ngStyle]="{'background-color': colorbat19}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage5_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage5_4 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 5 Bat.4</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage3_4 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage5_4 != null" [ngStyle]="{'background-color': colorbat20}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage5_4 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_1 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.1</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_1 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage6_1 != null" [ngStyle]="{'background-color': colorbat21}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage6_1 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_2 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.2</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_2 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage6_2 != null" [ngStyle]="{'background-color': colorbat22}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage6_2 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_3 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.3</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_3 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage6_3 != null" [ngStyle]="{'background-color': colorbat23}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage6_3 +" VDC" }}</td>
                    </tr>
                    <tr *ngIf="!isLionBMS && !parallelBatts && macSearchTelemetry.batteryVoltage6_4 != null && showTelemetryThreshold">
                        <td class="tablelabel"><b>String 6 Bat.4</b></td>
                        <!-- <td class="tablevalue">{{macSearchTelemetry.batteryVoltage4_4 +" VDC" }}</td> -->
                        <td *ngIf="macSearchTelemetry.batteryVoltage6_4 != null" [ngStyle]="{'background-color': colorbat24}"
                            style="float: left;" class="labelStruccolor">
                            {{macSearchTelemetry.batteryVoltage6_4 +" VDC" }}</td>
                    </tr>


            </table>
            <!--Color bar removed-->
            <!-- <table>
        <tr *ngIf="macSearchTelemetry.batteryVoltage1_1 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 1 Bat.1</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage1_1"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage1_2 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 1 Bat.2</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage1_2"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage1_3 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 1 Bat.3</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage1_3"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage1_4 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 1 Bat.4</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage1_4"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage2_1 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 2 Bat.1</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage2_1"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage2_2 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 2 Bat.2</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage2_2"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage2_3 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 2 Bat.3</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage2_3"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage2_4 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 2 Bat.4</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage2_4"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage3_1 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 3 Bat.1</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage3_1"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage3_2 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 3 Bat.2</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage3_2"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage3_3 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 3 Bat.3</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage3_3"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage3_4 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 3 Bat.4</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage3_4"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage4_1 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 4 Bat.1</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage4_1"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage4_2 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 4 Bat.2</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage4_2"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage4_3 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 4 Bat.3</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage4_3"></div>
            </td>
        </tr>
        <tr *ngIf="macSearchTelemetry.batteryVoltage4_4 != null && showTelemetryThreshold">
            <td class="tablelabel"><b>String 4 Bat.4</b></td>
            <td class="tablevalue">
                <div class="containerbat" id="batteryVoltage4_4"></div>
            </td>
        </tr>
        <br>
    </table> -->
            <div class="card"></div>
            <table>
                <tr>
                    <td class="tablelabel"><b>PS Output Frequency Support</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.psOutputFrequencySupport != null ? macSearchTelemetry.psOutputFrequencySupport : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>PS Frequency IN</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.psFrequencyIn != null ? macSearchTelemetry.psFrequencyIn + ' Hz' : '-' }}</td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>PS Frequency OUT</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.psFrequencyOut != null ? macSearchTelemetry.psFrequencyOut + ' Hz' : '-' }}</td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Bootfile</b></td>
                    <td class="tablevalue">{{ macSearchTelemetry.bootFile != null ? macSearchTelemetry.bootFile : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Information</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.information != null ? macSearchTelemetry.information : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>RMS Current IN</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.rmsCurrentIn != null ? macSearchTelemetry.rmsCurrentIn + " Amp(s)": '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Power IN</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.powerIn != null ? macSearchTelemetry.powerIn + " Watt(s)": '-' }}</td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Power OUT</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.powerOut != null ? macSearchTelemetry.powerOut + " Watt(s)": '-' }}</td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Output Current 1</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.outputCurrent1 != null ? macSearchTelemetry.outputCurrent1 +" Amp(s)": '-' }}
                    </td>
                </tr>
                <tr *ngIf="macSearchTelemetry.outputCurrent2 != null">
                    <td class="tablelabel"><b>Output Current 2</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.outputCurrent2 != null ? macSearchTelemetry.outputCurrent2 +" Amp(s)": '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Total Output Current</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.totalOutputCurrent != null ? macSearchTelemetry.totalOutputCurrent +" Amp(s)": '-' }}
                    </td>
                </tr><br>
            </table>
            <div class="headernw">
                <div>Transponder Info</div>
            </div>
            <table>
                <tr>
                    <td class="tablelabel"><b>Transponder IP</b></td>
                    <td class="tablevalue">
                        <span *ngIf="macSearchTelemetry.transponderIp != null">
                            <!--IPV4-->
                            <a *ngIf="ipCategory && !addUrl" matTooltip="AlphaNet DOCSIS Management Hub"
                            target="_blank" href="{{'http://' + macSearchTelemetry.transponderIp}}">
                            {{macSearchTelemetry.transponderIp}}
                            </a>

                             <!--IPV4-->
                            <a *ngIf="ipCategory && addUrl" matTooltip=" AlphaNet DOCSIS Management Hub" target="_blank"
                                href="{{'https://' + macSearchTelemetry.transponderIp}}">
                                {{macSearchTelemetry.transponderIp}}
                            </a>
                             <!--IPV6-->
                             <a *ngIf="!ipCategory" matTooltip="AlphaNet DOCSIS Management Hub" target="_blank"
                             href="{{'http://[' + macSearchTelemetry.transponderIp +']/'}}">
                             {{macSearchTelemetry.transponderIp}}
                              </a>
                        </span>
                        <span *ngIf="macSearchTelemetry.transponderIp == null">-</span>
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Transponder Name</b></td>
                    <td class="tablevalue">
                        <span *ngIf="macSearchTelemetry.psName != null">
                            <a matTooltip="Power Supply Detail and Edit" target="_blank"
                                href="{{'#/list?macAddress='+macSearchTelemetry.macAddress}}">{{macSearchTelemetry.psName}}</a>
                        </span>
                        <span *ngIf="macSearchTelemetry.psName == null">-</span>
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Transponder Node</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.nodes != null ? macSearchTelemetry.nodes : '-' }}
                        <img *ngIf="macSearchTelemetry.stormMode == 1" style="height: 30px;cursor:pointer;" matTooltip="Primary node is in Storm Mode" src="./assets/storm.png">
                    </td>
                </tr>
                <tr *ngIf="macSearchTelemetry.stormMode == 1">
                    <td class="tablelabel"><b>Pre Storm Mode Output Current</b></td>
                    <td class="tablevalue">
                        {{ stormOutputCurr }}
                    </td>
                </tr>
                <tr *ngIf="macSearchTelemetry.stormMode == 1">
                    <td class="tablelabel"><b>Pre Storm Mode Poll Time</b></td>
                    <td class="tablevalue">
                        {{ pollTimeStormMode}}
                    </td>
                </tr>
                <tr *ngIf="macSearchTelemetry.digitalNodeName != null">
                    <td class="tablelabel"><b>Digital Node</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.digitalNodeName }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Transponder Location</b></td>
                    <td class="tablevalue">
                        <a *ngIf="macSearchTelemetry.gpsLatitude && macSearchTelemetry.gpsLongitude" target="_blank"
                        href="https://www.google.com/maps/search/?api=1&query={{(gpsgreaterFlag) ? telementryData.gpsLatitude : telementryData.gpsLatitude | number:'.6' }},{{(gpsgreaterFlag) ? telementryData.gpsLongitude : telementryData.gpsLongitude | number:'.6'}}"
                        matTooltip="Show on Map">
                            <mat-icon *ngIf="macSearchTelemetry.gpsLatitude && macSearchTelemetry.gpsLongitude"> location_on</mat-icon></a>{{ macSearchTelemetry.psLocation != null ? macSearchTelemetry.psLocation : '-' }}
                        <p *ngIf="!macSearchTelemetry.gpsLatitude && !macSearchTelemetry.gpsLongitude">-</p>
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Transponder Model</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.transponderModel != null ? macSearchTelemetry.transponderModel : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Mac Address</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.macAddress != null ? macSearchTelemetry.macAddress : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>PS No</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.powerSupplyNo != null ? macSearchTelemetry.powerSupplyNo : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>CMTS</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.cmts != null ? macSearchTelemetry.cmts : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Battery Temperature( ° F / ° C )</b></td>
                    <td class="tablevalue" *ngIf="macSearchTelemetry.outsideTemperatureFahrenheit != null && macSearchTelemetry.outsideTemperatureCelsius != null">
                        {{ macSearchTelemetry.outsideTemperatureFahrenheit.toFixed(2) + '° F' }}
                        {{  '/ ' + macSearchTelemetry.outsideTemperatureCelsius + '° C'}}
                    </td>
                    <td class="tablevalue"
                        *ngIf="macSearchTelemetry.outsideTemperatureFahrenheit == null && macSearchTelemetry.outsideTemperatureCelsius == null">
                        -
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>#PS Connected</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.psConnectedCount != null ? macSearchTelemetry.psConnectedCount : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>PS Model</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.psModel != null ? macSearchTelemetry.psModel : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Input Voltage Support</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.inputVoltageSupport != null ? macSearchTelemetry.inputVoltageSupport : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Input Current Support</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.inputCurrentSupport != null ? macSearchTelemetry.inputCurrentSupport : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Input Power Support</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.inputPowerSupport != null ? macSearchTelemetry.inputPowerSupport : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Tamper Status</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.tamperStatus != null ? macSearchTelemetry.tamperStatus : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Vendor</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.transponderVendor != null ? macSearchTelemetry.transponderVendor : '-' }}
                    </td>
                </tr>
                <tr>
                    <td class="tablelabel"><b>Vendor Information</b></td>
                    <td class="tablevalue">
                        {{ macSearchTelemetry.vendorInfo != null ? macSearchTelemetry.vendorInfo : '-' }}
                    </td>
                </tr><br>
            </table>

            <div class="headernw">
                <div>Cable Modem</div>
            </div>
            <table>
                <tr>
                    <td class="tablelabelsnr"><b>Upstream RF</b></td>
                    <td class="tablevaluesnr">
                        <table *ngIf="macSearchTelemetry.upstreamFrequency">
                            <tr class="streamValueColHeader">
                                <td class="streamValueCol">Channel Frequency</td>
                                <!-- <td class="streamValueCol">Channel Power</td>
                                <td class="streamValueCol">Signal Noise</td> -->
                                <td class="streamValueCol">Status TxPower</td>
                            </tr>
                            <tr *ngFor="let item of macSearchTelemetry.upstreamFrequency">
                                <td>{{ item.channelFrequency != null ? item.channelFrequency / 1000000 : '-'}} MHz</td>
                                <!-- <td>{{ (item.channelPower) ? item.channelPower : '-'}}</td>
                                <td>{{ (item.signalNoise) ? item.signalNoise : '-'}}</td> -->
                                <td>{{ item.statusTxPower != null ? item.statusTxPower: '-'}}</td>
                            </tr>
                        </table>
                        <span *ngIf="!macSearchTelemetry.downstreamFrequency">-</span>
                    </td>
                </tr>
                <tr>
                    <td class="tablelabelsnr"><b>Downstream RF</b></td>
                    <td class="tablevaluesnr">
                        <table *ngIf="macSearchTelemetry.downstreamFrequency">
                            <tr class="streamValueColHeader">
                                <td class="streamValueCol">Channel Frequency</td>
                                <td class="streamValueCol">Channel Power</td>
                                <td class="streamValueCol">Signal Noise Decibel</td>
                                <!-- <td class="streamValueCol">Status TxPower</td> -->
                            </tr>
                            <tr *ngFor="let item of macSearchTelemetry.downstreamFrequency">
                                <td>{{ item.channelFrequency != null ? item.channelFrequency / 1000000 : '-'}} MHz</td>
                                <td>{{ item.channelPower != null ? item.channelPower : '-'}}</td>
                                <td>{{ item.signalNoiseDecibel != null ? item.signalNoiseDecibel : '-'}}</td>
                                <!-- <td>{{ (item.statusTxPower) ? item.statusTxPower: '-'}}</td> -->
                            </tr>
                        </table>
                        <span *ngIf="!macSearchTelemetry.downstreamFrequency">-</span>
                    </td>
                </tr>
                <tr>
                    <td class="tablelabelsnr"><b>SYS Uptime</b></td>
                    <td class="tablevaluesnr">
                        {{ macSearchTelemetry.sysUpTime != null ? macSearchTelemetry.sysUpTime : '-' }}</td>
                </tr>

                <tr>
                    <td class="tablelabelsnr"><b>Docs Dev SW Current</b></td>
                    <td class="tablevaluesnr">
                        {{ macSearchTelemetry.docsDevSwCurrentVers != null ? macSearchTelemetry.docsDevSwCurrentVers : '-' }}
                    </td>
                </tr>

                <tr>
                    <td class="tablelabelsnr"><b>Docs Server Config</b></td>
                    <td class="tablevaluesnr">
                        {{ macSearchTelemetry.docsDevServerConfigFile != null ? macSearchTelemetry.docsDevServerConfigFile : '-' }}
                    </td>
                </tr>


                <!-- <tr>
            <td class="tablelabel"><b>SYS Uptime</b></td>
            <td class="tablevalue">
                {{ macSearchTelemetry.sysUpTime != null ? macSearchTelemetry.sysUpTime : '-' }}
            </td>
        </tr>
        <tr>
            <td class="tablelabel"><b>Docs Dev SW Current</b></td>
            <td class="tablevalue">
                {{ macSearchTelemetry.docsDevSwCurrentVers != null ? macSearchTelemetry.docsDevSwCurrentVers : '-' }}
            </td>
        </tr>
        <tr>
            <td class="tablelabel"><b>Docs Server Config</b></td>
            <td class="tablevalue">
                {{ macSearchTelemetry.docsDevServerConfigFile != null ? macSearchTelemetry.docsDevServerConfigFile : '-' }}
            </td>
        </tr> -->
            </table>
            <br><br>
        </div>



    </mat-tab> <!--telemetry tab ends here-->
    <mat-tab label="Transponder Operations">
        <psnb-mobile-power-supply-selftestdata [powerSupplyId]="powerSupplyId" [ip]="ip" [macaddress]="macaddress"></psnb-mobile-power-supply-selftestdata>
    </mat-tab>
</mat-tab-group>
